import TitleInput from './inputs/title';
import BodyInput from './inputs/body';
import DescriptionInput from './inputs/description';
import './form.scss';

const UGCDraftFormFields = () => {
  return (
    <div className="post-form">
      <TitleInput />
      <DescriptionInput />
      <hr className="post-form__divider" />
      <BodyInput />
    </div>
  );
};

export default UGCDraftFormFields;
